import React from 'react';
import {getScreenSizes} from '../../utils/helpers'
import './style.css'
function MajorGrid(props) {
  const {opacity}=props
  const resolution = 96

  
      const {screenWidth,screenHeight} = getScreenSizes()
      const maxDim = screenWidth>screenHeight?screenWidth:screenHeight
      const xNum = Math.ceil(maxDim/2/resolution)*2+1
      let xArry = [];
      for (let i=0;i<xNum;i++) xArry.push((i-(xNum-1)/2)*resolution+maxDim/2)
        const style = {stroke:"rgb(186, 255, 255)",
    strokeWidth:"2"}
      const majorGridColumns = xArry.map((x,i)=>{
       return(<line key={i} x1={(x).toString()} x2={(x).toString()} y1="0" y2={maxDim.toString()} style={style} ></line>)
      })
      const majorGridRows = xArry.map((x,i)=>{
        return(<line key={i} y1={(x).toString()} y2={(x).toString()} x1="0" x2={maxDim.toString()} style={style} ></line>)
       })
        
     const gridStyle = {opacity:opacity?"1":"0"}    

    

  
  return (
    <div id="majorGridContainer" style={gridStyle}>
        <svg id="majorGrid" height={maxDim.toString()} width={maxDim.toString()} xmlns="http://www.w3.org/2000/svg">
            {majorGridRows}
            {majorGridColumns}
        </svg>
    </div>
  );
}

export default MajorGrid;
 